import {
  ApolloClient,
  InMemoryCache,
  NormalizedCacheObject,
  HttpLink
} from '@apollo/client'

export const goerliArbitrum = {
  Predy: {
    http: new HttpLink({
      uri: 'https://api.thegraph.com/subgraphs/name/predy-dev/predy-v320-arbitrum-goerli'
    })
  },
  Uniswap: {
    http: new HttpLink({
      uri: 'https://api.thegraph.com/subgraphs/name/predy-dev/predy-v320-uni-arbitrum-goerli'
    })
  }
}

export const arbitrum = {
  Predy: {
    http: new HttpLink({
      uri: 'https://api.thegraph.com/subgraphs/name/predy-dev/predy-v320-arbitrum'
    })
  },
  Uniswap: {
    http: new HttpLink({
      uri: 'https://api.thegraph.com/subgraphs/name/predy-dev/predy-v320-uni-arbitrum'
    })
  }
}

const predyArbitrumGoerli = new ApolloClient({
  link: goerliArbitrum.Predy.http,
  cache: new InMemoryCache()
})

const predyArbitrum = new ApolloClient({
  link: arbitrum.Predy.http,
  cache: new InMemoryCache()
})

const uniswapArbitrumGoerli = new ApolloClient({
  link: goerliArbitrum.Uniswap.http,
  cache: new InMemoryCache()
})

const uniswapArbitrum = new ApolloClient({
  link: arbitrum.Uniswap.http,
  cache: new InMemoryCache()
})

export const PredyClient: {
  [key: number]: ApolloClient<NormalizedCacheObject>
} = {
  42161: predyArbitrum,
  421613: predyArbitrumGoerli
}

export const UniswapClient: {
  [key: number]: ApolloClient<NormalizedCacheObject>
} = {
  42161: uniswapArbitrum,
  421613: uniswapArbitrumGoerli
}
